import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Urologist icon
 *
 * @category Medical
 */
const Urologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.543 4.838c-.15-.13-.4-.04-.65.2-2.94 4.06-6.34 1.38-10.31 1.47-3.66-.2-7.78 3.01-10.02-1.27-.21-.33-.7-.59-.81-.07-.13 1.23 1.08 2.26 2.07 2.81.19.13.53.33.54.55.04.26-.29.59-.67 1.07-1.1 1.3-1.19 3.57-1.15 4.48.04 1.15.2 2.39.73 3.45 1.51 2.99 5.14 2.78 6.69 6.31.37.69.71 1.54.93 2.2.18.85.51 1.13 1.37 1.17.78.02 1.64.1 1.96-.58.41-1.25 1.51-3.52 2.6-4.74.8-.95 1.96-1.46 3-2.03 1.94-.93 2.93-2.93 2.94-5.15.05-1.85-.06-4.09-1.29-5.39-.33-.4-1.33-.92-.52-1.37 1.02-.53 3.04-1.72 2.66-3.05l-.06-.06zm-4.75 14.58c-1.51.82-2.97 2.22-3.89 3.77-.72.92-1.16 2.84-2.64 2.46-.85-.42-.87-1.896-1.75-3.116-.7-1.05-1.663-2.014-2.713-2.674-1.23-.7-4.822-2.901-1.182-3.021 4.39-.07 8.525-1.929 13.075-2.249.7-.03 1.09.225 1.44.825.76 1.42-.81 3.245-2.17 3.885l-.16.1zm2.27-6.19c-.9.97-3.723.92-5.583 1.36-3.05.45-7.077 1.7-10.037 1.19-1.3-.29-1.88-1.43-1.84-2.66.21-4.51 5.2-5.33 8.98-5.3 3.34.2 7.66.486 8.55 3.996.08.49.27.974 0 1.314l-.09.1z"
        />
      </svg>
    );
  }
);

Urologist.displayName = 'Urologist';

export { Urologist };
